import React, { Fragment, } from 'react';
import { Button, } from 'reactstrap';
import { sumBy, groupBy, chunk, mapValues, orderBy, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { format as formatDate, } from 'date-fns';
import ellipsis from 'text-ellipsis';
import numeral from 'numeral';

import firebase from '../../firebase';
import { idWithTenant } from '../../shared/util';
import { fields, statuses, boxSizes, deliveryTypes, deliveryType, } from '../../shared/models/shippingRequest';
import { fieldDisplayValue, postalCodeWithHyphen, } from '../../shared/util';
import { deliveryTimes, prefectures, } from '../../shared/config';
import { newId } from '../../util';
import useQueryParams from '../hooks/useQueryParams';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import AdminPage from '../hocs/AdminPage';
import ShippingRequestFormModal from '../modals/ShippingRequestFormModal';
import ShippingRequestCsvFlowModal from '../modals/ShippingRequestCsvFlowModal';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import ExportButton from '../ExportButton';

const { entries } = Object;
const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const tenantsRef = db.collection('tenants');
const shippingRequestsRef = db.collectionGroup('shippingRequests');
const statusesByLabel = mapValues(keyBy(entries(statuses), _ => _[1].label), '0');
const shippingRequestsCsvInfoRef = db.collection('settings').doc('shippingRequestsCsvInfo');

function AdminShippingRequestsPickingList (props) {
  const generalSetting = useDocumentSubscription(db.collection('settings').doc('general'));
  const shippingRequestsCsvInfo = useDocumentSubscription(shippingRequestsCsvInfoRef);
  const shippingRequests = useDocumentsFetch(shippingRequestsCsvInfo && shippingRequestsCsvInfo.ids.map(_ => tenantsRef.doc(_.tenantId).collection('shippingRequests').doc(_.shippingRequestId)), [shippingRequestsCsvInfo]);
  const slipShippingRequests = shippingRequests.filter(_ => _.shippingOptionValues?.includes('slip'));
  const tenants = useDocumentsFetch(uniqBy(shippingRequests.map(_ => _.ref.parent.parent), 'id'), [shippingRequests]);
  const tenantsById = keyBy(tenants, 'id');
  const senders = useDocumentsFetch(uniqBy(slipShippingRequests.map(_ => _.ref.parent.parent.collection('senders').doc(_.senderId)), 'id'), [shippingRequests]);
  const sendersById = keyBy(senders, 'id');
  const products = useDocumentsFetch(uniqBy(shippingRequests.map(sr => sr.items.map(_ => sr.ref.parent.parent.collection('products').doc(_.productId))).flat(), idWithTenant), [shippingRequests]);
  const productsByIdByTenantId = mapValues(groupBy(products, 'ref.parent.parent.id'), _ => keyBy(_, 'id'));

  return (
    <div className="admin-shipping-requests-picking-list container-fluid">
      <table className="table table-bordered" style={{ pageBreakAfter: 'always', }}>
        <thead className="thead-light text-center">
          <tr className="text-nowrap">
            <th style={{ minWidth: 150 }}>出荷依頼ID</th>
            <th style={{ minWidth: 150 }}>商品ID</th>
            <th style={{ minWidth: 100 }}>出荷数量</th>
            <th style={{ minWidth: 150 }}>オプション</th>
            <th style={{ minWidth: 150 }}>品名</th>
            <th style={{ minWidth: 150 }}>配送方法</th>
          </tr>
        </thead>
        <tbody>
          {
            shippingRequests.map((shippingRequest) => {
              const { id, ref, type, shippingItems = [], items = [], orderNumber, postalCode, prefecture, city, address1, address2, name, phone, deliveryDate, deliveryTime = 'free', shippingOptionValues = [], status, adminNote, ref: { parent: { parent: { id: tenantId } } }, } = shippingRequest;
              const rowItems = items.length > 0 ? items : [{}];
              const tenant = tenantsById[tenantId];
              const productsById = productsByIdByTenantId[tenantId] || {};
              const _deliveryType = deliveryType(generalSetting, shippingRequest, productsById, tenant?.allowsMultiNeko);

              return tenant != null && (
                <Fragment key={idWithTenant(shippingRequest.ref)}>
                  {
                    rowItems.map((item, i) => {
                      const { productId, goodQuantity, ngQuantity } = item;
                      const product = productsById[productId];
                      return (
                        <tr key={id}>
                          {
                            i === 0 && (
                              <Fragment>
                                <td rowSpan={rowItems.length}>{tenant.id}-{id}</td>
                              </Fragment>
                            )
                          }
                          <td>{product && `${tenant.id}-${product.id}`}</td>
                          <td className="text-right">{goodQuantity}</td>
                          {
                            i === 0 && (
                              <Fragment>
                                <td rowSpan={rowItems.length}>
                                  {fieldDisplayValue(shippingOptionValues, fields({ type }).shippingOptionValues)}
                                </td>
                              </Fragment>
                            )
                          }
                          <td>{product && product.itemName}</td>
                          {
                            i === 0 && (
                              <Fragment>
                                <td rowSpan={rowItems.length}>{deliveryTypes[_deliveryType].label}</td>
                              </Fragment>
                            )
                          }
                        </tr>
                      )
                    })
                  }
                </Fragment>
              );
            })
          }
        </tbody>
      </table>
      {
        slipShippingRequests.map((shippingRequest, i) => {
          const { id, ref, name, senderId, items, } = shippingRequest;
          const tenant = tenantsById[ref.parent.parent.id];
          const sender = sendersById[senderId];
          const productsById = productsByIdByTenantId[ref.parent.parent.id] || {};

          return tenant != null && sender != null && (
            <div key={id} className="d-flex justify-content-center" style={{ fontSize: 15, pageBreakAfter: i !== (slipShippingRequests.length - 1) && 'always' }}>
              <div className="d-flex flex-column gap-4 p-5" style={{ width: 1000 }}>
                <div className="d-flex justify-content-center">
                  <h1 className="font-weight-bold" style={{ fontSize: 35 }}>納品書</h1>
                </div>
                <div className="d-flex justify-content-between align-items-end">
                  <div className="d-flex border-bottom p-2 justify-content-between" style={{ width: 300 }}>
                    <span>{name}</span>
                    <span>様</span>
                  </div>
                  <table className="table table-bordered m-0 w-auto">
                    <tbody>
                      <tr>
                        <td className="text-center">納品No.</td>
                        <td className="text-center"style={{ width: 180 }}>{idWithTenant(ref)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between">
                  <div style={{ whiteSpace: 'pre-line', width: 450, }}>
                    {tenant.slipHeaderText}
                  </div>
                  <div>
                    <div>{sender.name}</div>
                    <div>
                      {sender.postalCode.slice(0, 3) + '-' + sender.postalCode.slice(3)}
                    </div>
                    <div>
                      {[prefectures[sender.prefecture], sender.city, sender.address1].join('')}
                    </div>
                    <div>
                      {sender.address2}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <table className="table table-bordered table-sm">
                    <thead className="thead-light text-center">
                      <tr>
                        <th style={{ width: 50 }}>No.</th>
                        <th style={{ width: 850 }}>商品名</th>
                        <th style={{ width: 50 }}>数量</th>
                        <th style={{ width: 50 }}>単位</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        items.map((item, i) => {
                          const { productId, goodQuantity, ngQuantity } = item;
                          const product = productsById[productId];
                          return (
                            <tr key={id} className="text-center">
                              <td>{i+1}</td>
                              <td>{ellipsis(product?.name || '', 55)}</td>
                              <td>{numeral(goodQuantity ?? ngQuantity).format()}</td>
                              <td>個</td>
                            </tr>
                          )
                        })
                      }
                      {
                        Array(Math.max(30 - items.length, 0)).fill().map((i) => {
                          return (
                            <tr key={i} className="text-center">
                              <td>&nbsp;</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          )
                        })
                      }
                      <tr key={i} className="text-center">
                        <td className="text-right" colSpan={2}>合計</td>
                        <td>{numeral(sumBy(items, _ => _.goodQuantity ?? _.ngQuantity)).format()}</td>
                        <td>個</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          );
        })
      }
    </div>
  );
}

AdminShippingRequestsPickingList.forPrint = true;

export default AdminPage(AdminShippingRequestsPickingList);
